<template>
  <div class="profil-container">
    <h3 class="profil-title">
      Terima Kasih
    </h3>
    <div
      class="instruction-wrapper"
      v-if="!$store.state.k3lStore.is_vendor_done"
    >
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Formulir Pra-Kualifikasi K3L ini telah diisi oleh Perusahaan yang
          mengajukan dengan sebenar-benarnya.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Semua data yang diisikan dan/atau lampiran dokumen pendukung adalah
          benar dan akurat pada saat dokumen formulir Pra-Kualifikasi K3L ini
          diserahkan ke pihak PT Berau Coal.
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Jika data yang diisikan dan/atau lampiran dokumen pendukung yang
          diberikan tidak benar, tidak akurat dan tidak diketahui oleh Pimpinan
          Tertinggi Perusahaan maka tidak akan diperiksa dan Perusahaan tidak
          akan diundang untuk mengikuti proses selanjutnya.
        </div>
      </div>
      <div class="vendor-form mt40">
        <div
          class="input-100"
          style="display:flex; align-items:center; justify-content:center"
        >
          <input
            type="checkbox"
            value="1"
            v-model="selesai"
            v-if="!$store.state.k3lStore.is_vendor_done"
          />
          <input type="checkbox" value="1" v-model="done" v-else disabled />
          <label class="ml20"
            >Dengan ini menyatakan bahwa pernyataan yang telah diisi dan dokumen
            pendukung yang dilampirkan sudah benar, akurat dan lengkap serta
            menyetujui seluruh peraturan yang tertera diatas</label
          >
        </div>
      </div>
    </div>
    <div class="instruction-wrapper" v-else>
      <p class="profil-subtitle">
        Informasi dan Dokumen yang telah Anda submit sedang kami review lebih
        lanjut. Mohon selalu cek emailnya bertahap untuk notifikasi lebih lanjut
        dari kami.
      </p>
    </div>

    <div class="profil-btn-wrapper">
      <div
        @click="goProcess()"
        class="btn-landing"
        v-if="!$store.state.k3lStore.is_vendor_done"
      >
        Selesai
      </div>
      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selesai: 0,
      done: 1,
    }
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup78' })
    },
    goProcess() {
      if (this.selesai) {
        this.$store.commit('k3lStore/PROCESSING_K3L')
      } else {
        this.$store.commit(
          'SET_NOTIF',
          'Harap centang persetujuan jika untuk melanjutkan.'
        )
      }
    },
  },
}
</script>
